
//
document.querySelectorAll('form[name="new-online-advice-enquiry"]').forEach((enquiryForm) => {

    //
    const debounce      = require('../utils/debounce.js');
    const zenoFetch     = require('../utils/zenoFetch.js');
    const createElement = require('../utils/createElement.js');

    //this will be called by the validation system (if the form validates)
    enquiryForm.nrlaSubmitCallback = async () => {

        //
        enquiryForm.querySelector('.form-status-message')?.remove();

        //
        const enquiryFormData = new FormData(enquiryForm);

        //
        const [ status, message ] = await zenoFetch('post', '/api/new-online-advice-enquiry', null, enquiryFormData);

        //
        enquiryForm.insertAdjacentElement('afterbegin', createElement('p', { 'class' : 'form-status-message', 'data-status' : status }, message))

        //
        if (status == 'success') {
            enquiryForm.reset();
        }

    }

});